// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1_HJn","image":"card-module--image--z_PBt","bio":"card-module--bio--3a0yM"};